import { render, staticRenderFns } from "./decisions.vue?vue&type=template&id=0ce485e2&scoped=true&"
import script from "./decisions.vue?vue&type=script&lang=js&"
export * from "./decisions.vue?vue&type=script&lang=js&"
import style0 from "./decisions.vue?vue&type=style&index=0&id=0ce485e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce485e2",
  null
  
)

export default component.exports